import { render, staticRenderFns } from "./AdminDeleteTenderDocument.vue?vue&type=template&id=c28fd34a&"
import script from "./AdminDeleteTenderDocument.vue?vue&type=script&lang=js&"
export * from "./AdminDeleteTenderDocument.vue?vue&type=script&lang=js&"
import style0 from "./AdminDeleteTenderDocument.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports